import PageShell from '@/components/feature/PageShell';
import Seo from '@/components/base/Seo';
import HeroSection from '@/pages/home/components/HeroSection';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import CategorySection from '@/pages/home/components/CategorySection';
import LatestSection from '@/pages/home/components/LatestSection';
import TrustSection from '@/pages/home/components/TrustSection';
import TestimonialSection from '@/pages/home/components/TestimonialSection';
import FaqPreview from '@/pages/home/components/FaqPreview';
import CtaSection from '@/pages/home/components/CtaSection';
import { allArticles, getFeaturedArticles } from '@/lib/content';
import { faqs } from '@/mocks/faqs';
import { site } from '@/mocks/site';

export default function Home() {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const cover = getFeaturedArticles(1)[0];
  const previewFaqs = faqs.slice(0, 4);
  const highlights = allArticles.slice(0, 6);

  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: site.name,
      url: origin,
      description: site.intro,
      email: site.email,
      knowsLanguage: 'zh-CN',
      slogan: site.tagline,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: site.name,
      url: origin,
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${origin}/insight?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: `${site.name} - 职场内幕与劳动权益观察`,
      description: site.intro,
      url: origin,
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: highlights.map((article, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: article.title,
          url: `${origin}/insight/${article.id}`,
        })),
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: previewFaqs.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: { '@type': 'Answer', text: item.answer },
      })),
    },
  ];

  return (
    <PageShell>
      <Seo
        title="职镜观察 | 深挖平台运营内幕、管理层背景与员工爆料"
        description="职镜观察持续整理平台运营内幕、管理层背景、员工爆料、办公环境、裁员动向与薪资纠纷的真实线索，帮助职场人在做决定前看清企业真实情况。"
        keywords="职场内幕,运营内幕,老板背景,员工爆料,办公环境,裁员内幕,薪资纠纷"
        image={cover?.cover}
        jsonLd={jsonLd}
      />
      <HeroSection />
      <FeaturedSection excludeId={cover?.id} />
      <CategorySection />
      <LatestSection />
      <TrustSection />
      <TestimonialSection />
      <FaqPreview />
      <CtaSection />
    </PageShell>
  );
}